import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import {
  isQuiet,
  printQuiet,
  printJson,
  printKeyValue,
  printSuccess,
} from '../../output.js'

export const environmentsCreateCommand = new Command(`create`)
  .usage(`--project <id> --name <name>`)
  .description(`Create a new environment`)
  .requiredOption(`--project <id>`, `Project ID`)
  .requiredOption(`--name <name>`, `Environment name`)
  .action(async (opts) => {
    const json = environmentsCreateCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.projects.createEnvironment({
        projectId: opts.project,
        name: opts.name,
      })

      if (isQuiet()) {
        printQuiet(result.environmentId)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Environment created successfully.\n`)
        printKeyValue([[`ID:`, result.environmentId]])
      }
    } catch (error) {
      handleError(error, json)
    }
  })
